// smooth-scrollライブラリをインポート
import smoothScroll from 'smooth-scroll';

// ブレークポイントに応じたヘッダー高さを設定
// 768px未満: 70px、768px以上: 80px
let options = { 
  speed: 500,
  offset: window.innerWidth >= 768 ? 80 : 70
};

// smooth-scrollの初期化
let scroll = new smoothScroll('a[href*="#"]', options);

// ウィンドウリサイズ時にオフセットを更新
window.addEventListener('resize', () => {
  // 既存のインスタンスを破棄
  scroll.destroy();
  
  // 新しいオフセット値でオプションを更新
  options.offset = window.innerWidth >= 768 ? 80 : 70;
  
  // 新しいインスタンスを作成
  scroll = new smoothScroll('a[href*="#"]', options);
});

// ページロード時にURLハッシュがあれば、該当箇所にスクロール
document.addEventListener('DOMContentLoaded', () => {
  const hash = location.hash;
  
  if (hash && document.querySelector(hash)) {
    // スクロール位置をリセット
    window.scrollTo(0, 0);
    
    // 少し遅延させてからスクロールを実行
    setTimeout(() => {
      scroll.animateScroll(document.querySelector(hash), null, options);
    }, 700);
  }
});
